import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgStoveSteamerGas = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Regular",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "stove-steamer-gas" }),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-1",
			d: "M18,23.25l-1.121-2.021a.835.835,0,0,0-.691-.413.865.865,0,0,0-.744.332l-.073.1a.865.865,0,0,1-.744.332.838.838,0,0,1-.692-.413l-1.11-2a1.024,1.024,0,0,0-1.65,0l-1.11,2a.838.838,0,0,1-.692.413.865.865,0,0,1-.744-.332l-.073-.1a.865.865,0,0,0-.744-.332.835.835,0,0,0-.691.413L6,23.25"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-1",
			d: "M6.75,3.75h10.5a0,0,0,0,1,0,0v11a1,1,0,0,1-1,1H7.75a1,1,0,0,1-1-1v-11A0,0,0,0,1,6.75,3.75Z"
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "cls-1",
			x1: 5.25,
			y1: 3.75,
			x2: 18.75,
			y2: 3.75
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "cls-1",
			x1: 3.75,
			y1: 6.75,
			x2: 6.75,
			y2: 6.75
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "cls-1",
			x1: 3.75,
			y1: 11.25,
			x2: 6.75,
			y2: 11.25
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "cls-1",
			x1: 20.25,
			y1: 6.75,
			x2: 17.25,
			y2: 6.75
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "cls-1",
			x1: 20.25,
			y1: 11.25,
			x2: 17.25,
			y2: 11.25
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "cls-1",
			x1: 6.75,
			y1: 8.25,
			x2: 17.25,
			y2: 8.25
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-1",
			d: "M9,3.75a3,3,0,0,1,6,0"
		})
	]
});
export default SvgStoveSteamerGas;
